// import heroTwo from "../../asset/hero2.png" 
import heroTwo from "../../asset/homefivehero.png"
import { useNavigate } from "react-router-dom"

export default function HomeMain5() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/ContactUs");
  };

  return (
    <div className="min-h-screen bg-[#F5F6F7] flex items-center justify-center px-4 sm:px-6 md:px-8 py-8 md:py-12">
      <div className="max-w-[90rem] w-full grid grid-cols-1 lg:grid-cols-2 gap-10 xl:gap-16 items-center">
        
        {/* Left Content */}
        <div className="space-y-8 text-left lg:text-left">
          <div className="space-y-4">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl 2xl:text-7xl font-bold text-[#0A476C] leading-tight">
              Ready to Scale Your Law Firm With More Accident Cases?
            </h1>

            {/* Orange underline */}
            <div className="w-full h-1 sm:h-1.5 bg-[#FC821F] rounded-lg mx-auto lg:mx-0"></div>
          </div>

          <p className="text-[#0A476C] text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed max-w-2xl mx-auto lg:mx-0">
            We deliver exclusive, qualified accident leads nationwide. No setup fees. No long-term contracts. 
            Just results you can count on.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <button
              onClick={handleClick}
              className="px-8 py-4 text-base sm:text-lg font-semibold rounded-2xl 
                         bg-[#0A476C] text-white border-2 border-transparent 
                         hover:bg-[#FC821F] hover:text-[#0A476C] hover:border-[#0A476C] 
                         transition-colors duration-300"
            >
              Get a Free Lead Generation Plan
            </button>
          </div>
        </div>

        {/* Right Image */}
        <div className="relative flex justify-center lg:justify-end">
          <img
            src={heroTwo}
            alt="Law firm team working together"
            className="w-full max-w-2xl 2xl:max-w-4xl h-auto rounded-2xl shadow-md"
          />
        </div>
      </div>
    </div>
  );
}
